<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
        <vx-card title="New Review" class="mb-base" >
         
          <div class="vx-col flex-1">
               <div class="vx-row ">
                  <div class="  lg:w-1/3 w-full" style="padding-top:20px;padding-left:15px;padding-right:15px" >
               <vx-card class="flex-1" > <!-- inter filter data-->
         <div class="vx-col flex-1">
              
                  <div class="w-full mt-10">
                      <label class="vs-input--label">{{$t('Title')}}</label>  
                         <quill-editor v-model="InstructorReview.Title" :options="editorOption" />
                    </div>

                <div class=" vx-col flex-1" style="padding-left:5px" >  <!-- AssessmentType is course -->
    <p class="mt-5">categories</p>
<v-select
            label="Name"
            class="w-full"
            v-model="InstructorReview.CategoryInstructorAssessmentID"
            :options="categories"
            :reduce="value => value.ID"
            @input="get_question"
          />
              
                      <!-- <vs-select class="mt-5 w-full" label="categories" v-model="InstructorReview.CategoryInstructorAssessmentID" @change="get_question">
                                <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in categories" />
                      </vs-select> -->
                    <span class="text-danger text-sm"  v-show="errors.has('categories')">{{ errors.first('categories') }}</span>
                </div>
               
                 <div class=" vx-col flex-1" style="padding-left:5px" >
                    <vs-button class="ml-auto mt-2" @click="questions" :disabled="InstructorReview.ID>0">{{$t('ShowQuestion')}} </vs-button>
                 </div>
              </div>
            </vx-card>
                 </div>
                    <div class="vx-col lg:w-2/3 w-full" style="padding-top:20px;padding-left:15px;"> 
                     <div >
                      <vx-card class="flex-1">
                          <vs-table ref="table"   pagination :max-items="5"  :data="question" >
                            <template slot="thead">
                              <vs-th >{{$t('Question')}}  </vs-th>
                              <vs-th >{{$t('QuestionType')}}  </vs-th>
                              <vs-th style="padding-left:100px">{{$t('Answers')}}  </vs-th>
                               <vs-th >{{$t('Action')}}  </vs-th>
                            </template>

                              <template slot-scope="{data}">
                                
                                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                    <vs-td>
                                      <p class="product-name font-medium truncate">{{ tr.QuestionText }}</p>
                                    </vs-td>
                                    <vs-td>
                                      <p class="product-name font-medium truncate">{{ tr.QuestionType.Name }}</p>
                                    </vs-td>
                                    <vs-td>
                                      <vs-table ref="table"   :data="tr.AssessmentAnswers" >
                                                    <template slot-scope="{data}">
                                                 
                                                        <vs-th :data="da" :key="indextr" v-for="(da, indextr) in data">
                                                          
                                                          <vs-th>
                                                            <p class="product-name font-medium truncate">{{ da.AnswerText }}</p>
                                                          </vs-th>
                                                        </vs-th>
                                                    
                                                    </template>
                                                </vs-table>
                                    </vs-td>
                                    <vs-td>
                                      <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click="deleteQuestion(tr)" />
                                    </vs-td>
                                  </vs-tr>
                                
                              </template>
                          </vs-table>
                      </vx-card>
                       </div>
                      
                    </div>
             
         
               </div>
              
          </div>
 <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!isFormValid">{{$t('Submit')}} </vs-button>
          <vs-button class="ml-4 mt-2" type="border"  color="danger" @click="cancle">{{$t('Cancel')}}</vs-button>
        </div>
      </div>
    </div>
        </vx-card>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { quillEditor } from 'vue-quill-editor'
import moduleInstructorReview from "@/store/customerReview/instructorReview/moduleInstructorReview.js";
import moduleCourseClass from "@/store/courseClass/moduleCourseClass.js";
import moduleAssessmentInstructorQuestion from "@/store/question/assessmentInstructorQuestion/moduleAssessmentInstructorQuestion.js";
import vSelect from 'vue-select';

import axios from "@/axios.js"
export default {
  components:{
    quillEditor,
    vSelect
  },
  data() {
    
    return {
      selected: [],
       activePrompt:false,
      itemsPerPage: 10,
      isMounted: false,
      edit:false,
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      rowDataForDelete: {},
      activeConfirm: false,
      InstructorReview:{
        CustomerReviewQuestions:[],
        CustomerReviewAnswers:[],
      },
      question:[],
      dataForDeleted:{},
      categories:[],
    };
  },
  computed: {
  
    isFormValid() {
      debugger;
      return !this.errors.any() &&  this.InstructorReview.Title !=undefined;
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    // categories() {
    //   return this.$store.state.CategoryAssessmentList.CategoryAssessments;
    // },
    // courses() {
    //   debugger;
    //   return this.$store.state.courseList.courses;
    // },
     InstructorReviews() {
      return this.$store.state.InstructorReviewList.InstructorReviews;
    },
    
    courseClass() {
      debugger;
      return this.$store.state.courseClassList.courseClass;
    }
    //  AssessmentTypes() {
    //   return this.$store.state.AssessmentTypeList.AssessmentTypes;
    // },
  },

  methods: {
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    getCategories(){
      debugger;
      axios.get("api/CategoryInstructorAssessment/GetAll")
        .then((response) => {
          debugger;
          this.categories=response.data;
        })
    },
    questions(){
      debugger;
      if(this.InstructorReview.CategoryInstructorAssessmentID==undefined)
      {
        this.$store.dispatch("AssessmentInstructorQuestionList/getQuestionByFilter",this.InstructorReview);
      }
      
        
      this.question= this.$store.state.AssessmentInstructorQuestionList.AssessmentInstructorQuestionsByFilter;
    },
    get_question(){
      debugger;
        this.$store.dispatch("AssessmentInstructorQuestionList/getQuestionByFilter",this.InstructorReview);
    },
     deleteQuestion(data){
      debugger;
         const ItemIndex = this.question.findIndex((p) => p.ID == data.ID)
      //if(ItemIndex!=-1)
          this.question.splice(ItemIndex, 1)
    },
      save_changes() {
         debugger;
         this.InstructorReview.AssessmentTypeID=1;
         this.InstructorReview.CustomerReviewQuestions=this.question;
         for( let i =0 ; i<this.question.length;i++)
         {
           this.InstructorReview.CustomerReviewQuestions[i].CustomerReviewAnswers=[];
           this.InstructorReview.CustomerReviewQuestions[i].CustomerReviewAnswers=this.question[i].AssessmentAnswers;
         }
          if (this.InstructorReview.ID != null && this.InstructorReview.ID >= 0) {
            //edit 
            console.log("edit")
          } else {
           this.$store.dispatch("InstructorReviewList/addItem", this.InstructorReview);
           this.$store.state.InstructorReviewList.search.pageNum=1;
              this.cancle();   
          } 
    },
    cancle(){
       this.$router.go(-1);
    },
   
  },

  created() {
    debugger;
     this.getCategories();
    if (!moduleInstructorReview.isRegistered) {
      this.$store.registerModule("InstructorReviewList", moduleInstructorReview);
      moduleInstructorReview.isRegistered = true;
    }
     if (!moduleCourseClass.isRegistered) {
      this.$store.registerModule("courseClassList", moduleCourseClass);
      moduleCourseClass.isRegistered = true;
    }
    if (!moduleAssessmentInstructorQuestion.isRegistered) {
      this.$store.registerModule("AssessmentInstructorQuestionList", moduleAssessmentInstructorQuestion);
      moduleAssessmentInstructorQuestion.isRegistered = true;
    }
   
    this.$store.dispatch("courseClassList/fetchDataListItems");
    this.$store.dispatch("InstructorReviewList/fetchDataListItems");
     const ID = this.$route.params.ID
     if(ID!=undefined)
     {

      this.$store.dispatch("InstructorReviewList/GetItemByID", ID)
      .then(res => { 
        this.InstructorReview = res.data;
         this.question=res.data.CustomerReviewQuestions;
          for( let i =0 ; i<this.InstructorReview.CustomerReviewQuestions.length;i++)
         {
           this.question[i].AssessmentAnswers=[];
           this.question[i].AssessmentAnswers=this.InstructorReview.CustomerReviewQuestions[i].CustomerReviewAnswers;
         }
        debugger;
       })
      .catch(err => {
         debugger;
        if(err.response.status === 404) {
          this.user_not_found = true
          return
        }
        console.error(err) })
     }
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
